export const modalConstants = {
  update: 'update',
  delete: 'delete',
  create: 'create',
};

export const cfStoreTypeList = ['COCO BUILT', 'COCO ACQUIRED'];
